import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { selectPrize } from "@/utils/prizeUtils";
import { useToast } from "@/hooks/use-toast";
//import { initTlLockupPrice } from "@/utils/gsapAnimations_price";

export default function PrizePage() {
  const [prize, setPrize] = useState<{ name: string; description: string } | null>(null);
  const { toast } = useToast();
  const navigate = useNavigate();
  const { tipId } = useParams();

  useEffect(() => {
    // Validate tipId is a valid number
    if (!tipId || isNaN(parseInt(tipId))) {
      console.error('Invalid tip ID:', tipId);
      toast({
        variant: "destructive",
        title: "Error",
        description: "Invalid tip ID provided.",
      });
      navigate('/');
      return;
    }
    
    console.log("Initializing and playing the GSAP animation");
   // initTlLockupPrice();
  }, [tipId, navigate, toast]);

  useEffect(() => {
    const getPrize = async () => {
      try {
        // Ensure tipId is a valid number before proceeding
        const numericTipId = parseInt(tipId!);
        if (isNaN(numericTipId)) {
          throw new Error('Invalid tip ID');
        }

        console.log("Selecting prize for tip:", numericTipId);
        const wonPrize = await selectPrize(numericTipId);

        if (wonPrize) {
          console.log("Prize won:", wonPrize);
          setPrize(wonPrize);
        }
      } catch (error) {
        console.error("Error getting prize:", error);
        toast({
          variant: "destructive",
          title: "Error",
          description: "Something went wrong while selecting your prize. Please try again.",
        });
        navigate('/');
      }
    };

    if (tipId) {
      getPrize();
    }
  }, [tipId, navigate, toast]);

  return (
    <div className="min-h-screen bg-gradient-to-br">
      <div className="container mx-auto px-4 py-8">
        <div className="text-center">
          <div
            className="relative"
            id="Price_KV"
            style={{ display: "flex", justifyContent: "center" }}
          >
            <div className="absolute w-full max-w-[725px] h-auto KV-1_G" id="Price_KV-1_G">
              <img
                src="/imgs/KV-1.png"
                alt="Live Your Best Lip!"
                className="w-full h-auto"
                id="Price_KV-1"
              />
            </div>
            <div className="absolute w-full max-w-[725px] h-auto KV-1_G" id="Price_KV-1_G2">
              <img
                src="/imgs/KV-1B.png"
                alt="Live Your Best Lip!"
                className="w-full h-auto"
                id="Price_KV-1B"
              />
            </div>
            <div className="absolute w-full max-w-[725px] h-auto" id="Price_KV-2_G">
              <img
                src="/imgs/KV-2.png"
                alt="Live Your Best Lip!"
                className="absolute w-full h-auto"
                id="Price_KV-2"
              />
            </div>
            <div className="absolute w-full max-w-[725px] h-auto floating">
              <img
                src="/imgs/KV-3.png"
                alt="Live Your Best Lip!"
                className="absolute w-full h-auto"
                id="Price_KV-3"
              />
            </div>
            <div className="absolute w-full max-w-[725px] h-auto floating2">
              <img
                src="/imgs/KV-4.png"
                alt="Live Your Best Lip!"
                className="absolute w-full h-auto"
                id="Price_KV-4"
              />
            </div>
            <div className="absolute w-full max-w-[725px] h-[678px]" id="Price_KV-5_G">
              <img
                src="/imgs/KV-5.png"
                alt="Live Your Best Lip!"
                className="absolute w-full h-auto"
                id="Price_KV-5"
              />
            </div>
            <div className="absolute w-full max-w-[725px] h-[678px]" id="Price_KV-6-7_G">
              <img
                src="/imgs/KV-6.png"
                alt="Live Your Best Lip!"
                className="absolute w-full h-auto"
                id="Price_KV-6"
              />
              <img
                src="/imgs/KV-7.png"
                alt="Live Your Best Lip!"
                className="absolute w-full h-auto"
                id="Price_KV-7"
              />
            </div>
          </div>

          {prize && (
            <div className="mt-8 p-6 bg-white/10 backdrop-blur-sm rounded-lg shadow-xl">
              <h2 className="text-3xl font-bold text-white mb-4">Congratulations!</h2>
              <p className="text-xl text-white mb-2">You won:</p>
              <div className="text-2xl font-bold text-vaseline-pink mb-4">{prize.name}</div>
              {prize.description && (
                <p className="text-white/80">{prize.description}</p>
              )}
              <button
                onClick={() => navigate('/')}
                className="mt-6 px-8 py-3 bg-gradient-to-r from-vaseline-pink to-vaseline-blue text-white rounded-full 
                          hover:from-vaseline-blue hover:to-vaseline-pink transition-all duration-300 
                          shadow-lg hover:shadow-xl transform hover:-translate-y-1"
              >
                Back to Home
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}